import React from 'react'
import { Tooltip } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'

import styles from './detail.module.scss'

const HelpHint = ({ title }) => (
  <Tooltip title={title}>
    <span className={styles.helpIcon}>
      <QuestionCircleOutlined />
    </span>
  </Tooltip>
)

export default HelpHint
